"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontWeight = void 0;
var FontWeight;
(function (FontWeight) {
    FontWeight["Lighter"] = "u-font-lighter";
    FontWeight["LighterImportant"] = "u-font-lighter!";
    FontWeight["Regular"] = "u-font-regular";
    FontWeight["RegularImportant"] = "u-font-regular!";
    FontWeight["Bold"] = "u-font-bold";
    FontWeight["BoldImportant"] = "u-font-bold!";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
//# sourceMappingURL=FontWeight.js.map